import script from "./image-upload.vue?vue&type=script&setup=true&lang=ts"
export * from "./image-upload.vue?vue&type=script&setup=true&lang=ts"

import "./image-upload.vue?vue&type=style&index=0&id=24b70650&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24b70650"]])

export default __exports__